import * as React from "react";

function SvgFullstoryIcon(props, ref) {
  return (
    <svg height="1em" viewBox="0 0 64 64" width="1em" {...{ ...props, ref }}>
      <linearGradient
        id="fullstory-icon_svg__a"
        gradientTransform="matrix(1 0 0 -1 0 66)"
        gradientUnits="userSpaceOnUse"
        x1={76.224}
        x2={-9.888}
        y1={-10.224}
        y2={75.888}
      >
        <stop offset={0} stopColor="#d44b92" />
        <stop offset={0.52} stopColor="#f0617d" />
        <stop offset={1} stopColor="#f3874a" />
      </linearGradient>
      <path d="M0 0h64v64H0z" fill="url(#fullstory-icon_svg__a)" />
      <path
        clipRule="evenodd"
        d="M29.6 53.8c2.2 1.5 5.8 2.4 9.3 2.4 6.5 0 11.4-2.8 11.4-9.1 0-5.4-3-8-9.9-9.5-3.5-.9-4.8-2-4.8-3.9s1.6-3.4 4.5-3.4c3.2 0 5.8 1.1 8.4 3v-6.1C46 25.7 43.3 25 39.9 25c-6.1 0-10.8 3-10.8 9.1 0 5.2 2.7 7.7 8.9 9.1 3.9 1 5.7 1.9 5.7 4.3s-2 3.4-5 3.4c-3.1 0-6.4-1.3-9.2-3.4zm-1.4-22.5h-3.1v24.3h-6.7V31.3h-4.7v-5.6h4.7V20c0-7.4 4.1-11 10.5-11 2.4 0 4.2.5 5.9 1.5v6.1c-1.6-1.1-3.1-1.7-5.2-1.7-2.9 0-4.5 1.4-4.5 5.1v5.7h7.3c-2.2 1.1-3.7 3.1-4.2 5.6z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFullstoryIcon);
